import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ReactTable from "react-table";
import moment from "moment";
import Spinner from "../../../common/Spinner";
import {
    createMerchandiserCharges,
    fetchMissingClientCharges,
    getMissingMerchandiserCharges
} from "../../../../api/menu/invoicing/actions";
import CustomCheckbox from "../../../custom/forms/custom-checkbox";
import filterCaseInsensitive from "../../../custom/forms/react-table-case-insensitive";
import MissingChargesHeader from "./missingChargesHeader";

class MissingMerchandiserChargesList extends React.Component {
    dateFormat = "YYYY-MM-DD";

    constructor(props) {
        super(props);

        this.state = {
            fromDate: moment(moment().startOf("month").format(this.dateFormat)),
            selectedMissingMerchandiserCharges: []
        };

        this.handleLoadData = this.handleLoadData.bind(this);
        this.setFromDate = this.setFromDate.bind(this);
        this.handleCreateCharge = this.handleCreateCharge.bind(this);
        this.setSelectedMissingMerchandiserCharges =
            this.setSelectedMissingMerchandiserCharges.bind(this);
    }

    handleCreateCharge() {
        const { selectedMissingMerchandiserCharges } = this.state;

        this.props.createMerchandiserCharges(
            selectedMissingMerchandiserCharges,
            this.handleLoadData
        );
    }

    handleLoadData() {
        const date = this.state.fromDate && moment(this.state.fromDate).format(this.dateFormat);
        this.props.getMissingMerchandiserCharges(date);
    }

    componentDidMount() {
        const date = this.state.fromDate && moment(this.state.fromDate).format(this.dateFormat);
        this.handleLoadData();
        this.props.getMissingClientCharges(date);
    }

    setFromDate(date) {
        this.setState({
            fromDate: date
        });
    }

    setSelectedMissingMerchandiserCharges(id) {
        const selectedCharges = Object.assign([], this.state.selectedMissingMerchandiserCharges);

        const index = selectedCharges.indexOf(id);

        if (index >= 0) {
            selectedCharges.splice(index, 1);
        } else {
            selectedCharges.push(id);
        }

        this.setState({
            selectedMissingMerchandiserCharges: selectedCharges
        });
    }

    onToggle = () => {
        const { selectedMissingMerchandiserCharges } = this.state;
        const { missingMerchandiserCharges } = this.props;

        const selectedCharges =
            selectedMissingMerchandiserCharges.length === missingMerchandiserCharges.length ?
                [] : missingMerchandiserCharges.map(i => i.serviceId);

        this.setState({
            selectedMissingMerchandiserCharges: selectedCharges
        });
    };

    getColumns = () => {
        const { selectedMissingMerchandiserCharges } = this.state;
        const { missingMerchandiserCharges } = this.props;

        const columns = [];

        columns.push({
            Cell: ({ original }) => (
                <CustomCheckbox
                    key={original.serviceId}
                    className="checkbox"
                    checked={selectedMissingMerchandiserCharges.includes(original.serviceId)}
                    onChange={() => this.setSelectedMissingMerchandiserCharges(original.serviceId)}
                />
            ),
            headerClassName: "text-left",
            Header: () => (
                <input
                    type="checkbox"
                    className="checkbox"
                    checked={selectedMissingMerchandiserCharges.length ?
                        selectedMissingMerchandiserCharges.length ===
                        missingMerchandiserCharges.length : false}
                    onChange={() => this.onToggle()}
                />
            ),
            sortable: false,
            filterable: false,
            resizable: false,
            minResizeWidth: 40,
            width: 40,
            className: "d-flex"
        });
        columns.push({
            Header: "Merchandiser",
            headerClassName: "text-left",
            accessor: "merchandiser"
        });
        // columns.push({
        //     Header: "Job",
        //     headerClassName: "text-left",
        //     accessor: original => moment(original.dateIssued).format(this.dateFormat)
        // });
        columns.push({
            Header: "Job",
            headerClassName: "text-left",
            accessor: "jobNumber"
        });
        columns.push({
            Header: "Store",
            headerClassName: "text-left",
            accessor: "storeNumber"
        });
        columns.push({
            Header: "Retailer",
            headerClassName: "text-left",
            accessor: "retailer"
        });
        columns.push({
            id: "completed",
            Header: "Completed",
            headerClassName: "text-left",
            accessor: original => (original.completedDate ?
                moment(original.completedDate).format("DD/MM/YYYY") : "")
        });
        columns.push({
            id: "submitted",
            Header: "Submitted",
            headerClassName: "text-left",
            accessor: original => moment(original.dateReportSubmitted).format("DD/MM/YYYY hh:mm A")
        });
        columns.push({
            Header: "Hours",
            headerClassName: "text-left",
            accessor: "billableHours"
        });
        columns.push({
            Header: "Hourly Rate",
            headerClassName: "text-left",
            accessor: "payratePerHour"
        });
        columns.push({
            Header: "Flat Rate",
            headerClassName: "text-left",
            accessor: "payrateFlat"
        });
        columns.push({
            id: "Activated",
            Header: "Activated?",
            headerClassName: "text-left",
            accessor: original => (original.isActivated ? "Yes" : "No"),
            Cell: ({ original }) => (original.isActivated ? "Yes" : "No"),
        });
        columns.push({
            id: "Submitted",
            Header: "Submitted?",
            headerClassName: "text-left",
            accessor: original => (original.isSubmitted ? "Yes" : "No"),
            Cell: ({ original }) => (original.isSubmitted ? "Yes" : "No"),
        });
        columns.push({
            id: "Exported",
            Header: "Exported?",
            headerClassName: "text-left",
            accessor: original => (original.isHistory ? "Yes" : "No"),
            Cell: ({ original }) => (original.isHistory ? "Yes" : "No"),
        });

        return columns;
    };

    render() {
        const { selectedMissingMerchandiserCharges } = this.state;
        const { missingMerchandiserCharges } = this.props;

        const enableCreate = Array.isArray(selectedMissingMerchandiserCharges) &&
            selectedMissingMerchandiserCharges.length > 0;

        const selectedText = selectedMissingMerchandiserCharges.length ?
            `Selected ${selectedMissingMerchandiserCharges.length} out of ${missingMerchandiserCharges.length}` : "";

        return (
            <div className="dashboard">
                <div className="position-relative">
                    {!this.props.missingMerchandiserChargesLoading || <Spinner/>}
                    <MissingChargesHeader
                        fromDate={this.state.fromDate}
                        selectedText={selectedText}
                        handleLoad={this.handleLoadData}
                        handleCreate={this.handleCreateCharge}
                        setFromDate={this.setFromDate}
                        enableCreate={enableCreate}
                    />
                    <ReactTable
                        data={missingMerchandiserCharges}
                        columns={this.getColumns()}
                        headerClassName="table-header"
                        showPagination={false}
                        pageSize={Math.max(missingMerchandiserCharges.length, 20)}
                        resizable
                        className="-striped -highlight"
                        filterable={false}
                        defaultFilterMethod={filterCaseInsensitive}
                        getNoDataProps={() => ({
                            style: {
                                zIndex: 0
                            }
                        })}
                        style={{
                            height: "calc(100vh - 180px)",
                        }}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    missingMerchandiserChargesLoading: state.invoicing.missingMerchandiserChargesLoading,

    missingMerchandiserCharges: state.invoicing.missingMerchandiserCharges
});

const mapStateToDispatch = dispatch => ({
    getMissingMerchandiserCharges: bindActionCreators(getMissingMerchandiserCharges, dispatch),
    getMissingClientCharges: bindActionCreators(fetchMissingClientCharges, dispatch),
    createMerchandiserCharges: bindActionCreators(createMerchandiserCharges, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(MissingMerchandiserChargesList);
